<script>
  // This component is used only by ShowCompleteYaoInfo

  export let numStr
  export let gua_code
  export let yaoColorArray
  export let sectionName
  import YinYao from "./YinYao.svelte"
  import YangYao from "./YangYao.svelte"
  import GuaBriefing from "./GuaBriefing.svelte"
  import { selectedLanguage } from "../etc/store.js"
  import {
    number2code,
    findGua,
    reverseString,
    checkChanging,
    getMovingYaoPositions,
    checkChangingMatch,
    checkMoving,
    generateZhi1Code,
    generateZhi1,
    zongGua,
    cuoGua,
    jiaoGua,
    huGua,
    gig14,
    gig15,
    gig26,
    gig36,
  } from "../etc/helpers.js"
  import { changingMap } from "../etc/allNumbers"

  //console.log("@ReactiveAllGuas: got called from " + sectionName)
  let btn_effect = "waves-effect waves-light blue lighten-3"
  let reversed_code = ""
  let size = ""
  let changingYaoPosition = ""
  let movingYaos = ""
  let movingYaoArray = []
  let matchingMessage = ""
  let readyToChange = false
  let tmpYaoColorArray = []
  let zhi1_code = ""
  let zhi1_code_reversed = ""
  let zhi2_code = ""
  let zhi2_code_reversed = ""
  let hasZhiGua = false

  let i
  let zhi1ColorArray = []
  let zhi2ColorArray = []
  let numStr_reversed = ""
  $: if (numStr != null) {
    hasZhiGua = false
    reversed_code = reverseString(gua_code)
    //console.log("@ ReactiveALlGuas.reversed_code = " + reversed_code)
    //console.log("@ ReactiveALlGuas.yaoColorArry = ")
    //console.log(yaoColorArray)

    numStr_reversed = reverseString(numStr)
    changingYaoPosition = checkChanging(numStr)
    movingYaoArray = getMovingYaoPositions(numStr).split(",")
    movingYaos = getMovingYaoPositions(numStr)
    matchingMessage = checkChangingMatch(numStr)

    tmpYaoColorArray = [...yaoColorArray]
    readyToChange = false

    // if (movingYaos != "無動爻") {
    if (movingYaos != "unmoved") {
      //console.log("!!!! MovingYaos Length " + movingYaos.length)
      // console.log(
      //   "@ ReactiveALlGuas check if has ZhiGua. Moving Yaos = " + movingYaos
      // )
      hasZhiGua = true
    }

    zhi1_code = ""
    zhi2_code = generateZhi1Code(numStr_reversed)
    if (movingYaoArray.includes(changingYaoPosition)) {
      readyToChange = true
      tmpYaoColorArray[6 - changingYaoPosition] = "change"
      // console.log(
      //   "@ ReactiveALlGuas.readyToChange is True! changingYaoPosition = " +
      //     changingYaoPosition
      // )

      // makng zhi1 gua code by changing only the changingYaoPosition from the original gua_code
      for (i = 0; i < 6; i++) {
        if (i == changingYaoPosition - 1) {
          if (gua_code[i] == 0) {
            zhi1_code = zhi1_code + "1"
          } else {
            zhi1_code = zhi1_code + "0"
          }
        } else {
          zhi1_code = zhi1_code + gua_code[i]
        }
      }

      // Just to remind myself: when there is a changing yao, use the reversed zhi1_code
      // for 1st Zhi gua pic generation ONLY.
      //      zhi1_code_reversed = reverseString(zhi1_code)
      zhi1_code = reverseString(zhi1_code)
      // zhi2_code_reversed = reverseString(zhi2_code)
      // console.log(
      //   "@ ReactiveAllGuas has changing zhi1_code_reversed = " +
      //     zhi1_code_reversed
      // )
      // console.log(
      //   "@ ReactiveAllGuas has changing zhi2_code_reversed = " +
      //     zhi2_code_reversed
      // )
    }

    // If not changingYao zhi1_code = zhi2_code
    if (zhi1_code == "") {
      zhi1_code = zhi2_code

      // Just to remind myself: when there is no changing yao, use non-reversed zhi_code
      // for gua pic generation.
      // zhi1_code_reversed = reverseString(zhi1_code)
      // zhi2_code_reversed = reverseString(zhi2_code)
      // console.log(
      //   "@ ReactiveAllGuas **not** changing zhi1_code_reversed = " +
      //     zhi1_code_reversed
      // )
      // console.log(
      //   "@ ReactiveAllGuas **not** changing zhi2_code_reversed = " +
      //     zhi2_code_reversed
      // )
    }
  }

  let displayGuaInfo = false
  let selectedGuaNumStr = ""
  let previousGuaNumStr = "xxxxxx"
  $: if (selectedGuaNumStr == previousGuaNumStr) {
    displayGuaInfo = false
    //console.log("@ ReactiveAllGuas: previous gua clicked " + previousGuaNumStr)
    //console.log("@ ReactiveAllGuas: now same gua clicked " + selectedGuaNumStr)
  } else {
    if (selectedGuaNumStr == "") {
      displayGuaInfo = false
    } else {
      displayGuaInfo = true
    }
  }

  function showGua(gua) {
    // if (selectedGuaNumStr == previousGuaNumStr) {
    //   displayGuaInfo = !displayGuaInfo
    //   console.log(
    //     "@ ReactiveAllGuas: previous gua clicked " + previousGuaNumStr
    //   )
    //   console.log(
    //     "@ ReactiveAllGuas: now same gua clicked " + selectedGuaNumStr
    //   )
    // } else {
    //   displayGuaInfo = true

    if (gua == "zhi1") {
      selectedGuaNumStr = generateZhi1Code(numStr)
      //console.log("@ ReactiveAllGuas: show zhi1") + selectedGuaNumStr
    } else if (gua == "zhi2") {
      selectedGuaNumStr = checkMoving(numStr)
      //console.log("@ ReactiveAllGuas: show zhi2") + selectedGuaNumStr
    } else if (gua == "gua-z") {
      selectedGuaNumStr = zongGua(number2code(numStr))
      //console.log("@ ReactiveAllGuas: show gua-z " + selectedGuaNumStr)
    } else if (gua == "gua-c") {
      selectedGuaNumStr = cuoGua(number2code(numStr))
      //console.log("@ ReactiveAllGuas: show gua-c " + selectedGuaNumStr)
    } else if (gua == "gua-j") {
      selectedGuaNumStr = jiaoGua(number2code(numStr))
      //console.log("@ ReactiveAllGuas: show gua-j " + selectedGuaNumStr)
    } else if (gua == "gua-h") {
      selectedGuaNumStr = huGua(number2code(numStr))
      //console.log("@ ReactiveAllGuas: show gua-h " + selectedGuaNumStr)
    } else if (gua == "gig14") {
      selectedGuaNumStr = gig14(number2code(numStr))
      //console.log("@ ReactiveAllGuas: show gig14 " + selectedGuaNumStr)
    } else if (gua == "gig15") {
      selectedGuaNumStr = gig15(number2code(numStr))
      //console.log("@ ReactiveAllGuas: show gig15 " + selectedGuaNumStr)
    } else if (gua == "gig26") {
      selectedGuaNumStr = gig26(number2code(numStr))
      //console.log("@ ReactiveAllGuas: show gig26 " + selectedGuaNumStr)
    } else if (gua == "gig36") {
      selectedGuaNumStr = gig36(number2code(numStr))
      //console.log("@ ReactiveAllGuas: show gig36 " + selectedGuaNumStr)
    } else {
      selectedGuaNumStr = ""
      // console.log("@ ReactiveAllGuas: something wrong and show nothing")
    }
    // }
    //previousGuaNumStr = selectedGuaNumStr
  }

  // function genYaoColor(numStr) {
  //   let colorArray = []

  //   for (var i = 0; i < 6; i++) {
  //     if (numStr[i] == 6 || numStr[i] == 9) {
  //       colorArray.push("unstable")
  //     } else {
  //       colorArray.push("")
  //     }
  //   }

  //   return colorArray
  // }
  // $: if (movingYaoArray.length != 0) {
  //   // Handle Zhi1
  //   zhi1_code = generateZhi1Code(number2code(numStr))
  // }
</script>

<div class="reactive-all ">
  <div class="gua-header indigo lighten-4">
    <div class="gua-name center">
      <strong> 本卦：</strong>{numStr.length != 6
        ? ""
        : findGua(number2code(numStr), $selectedLanguage)}
      <div class="gua-pic">
        {#each reversed_code as digit, i}
          {#if digit == "0"}
            <YinYao yaoColor={tmpYaoColorArray[i]} size={"size2"} />
          {:else}
            <YangYao yaoColor={tmpYaoColorArray[i]} size={"size2"} />
          {/if}
        {/each}
      </div>
    </div>
    <div class="gua-changing-info">
      {#if $selectedLanguage == "TW"}
        <div class="yao-changing">
          <strong>宜變之爻：</strong>{changingYaoPosition}
        </div>
        <div class="yao-moving">
          <strong>動爻：</strong>{movingYaos == "unmoved"
            ? "無動爻"
            : movingYaos}
          /
          {checkChangingMatch(numStr) == "unchanged"
            ? "無宜變"
            : checkChangingMatch(numStr) + "爻值宜變"}
        </div>
      {:else}
        <div class="yao-changing">
          <strong>宜变之爻：</strong>{changingYaoPosition}
        </div>
        <div class="yao-moving">
          <strong>动爻：</strong>{movingYaos == "unmoved"
            ? "无动爻"
            : movingYaos}
          /
          {checkChangingMatch(numStr) == "unchanged"
            ? "无宜变"
            : checkChangingMatch(numStr) + "爻值宜变"}
        </div>
      {/if}
    </div>
  </div>

  <div class="optional" style="display:{hasZhiGua ? 'block' : 'none'}">
    <div class="zhi-gua-row ">
      <div
        class={"zhi1 gua-btn " + btn_effect}
        on:click={() => showGua("zhi1")}
      >
        <strong>第一之卦：</strong>{generateZhi1(numStr)}
        <div class="gua-pic">
          {#each reverseString(generateZhi1Code(numStr)) as digit, i}
            <!-- {#each zhi1_code as digit, i} -->
            {#if digit == "0"}
              <YinYao yaoColor={""} size={"size2"} />
            {:else}
              <YangYao yaoColor={""} size={"size2"} />
            {/if}
          {/each}
        </div>
      </div>

      {#if zhi1_code != zhi2_code}
        <div
          class={"zhi2 gua-btn " + btn_effect}
          on:click={() => showGua("zhi2")}
        >
          <strong>第二之卦：</strong>{findGua(
            checkMoving(numStr),
            $selectedLanguage
          )}
          <div class="gua-pic">
            {#each reverseString(checkMoving(numStr)) as digit, i}
              <!-- {#each zhi2_code as digit, i} -->
              {#if digit == "0"}
                <YinYao yaoColor={""} size={"size2"} />
              {:else}
                <YangYao yaoColor={""} size={"size2"} />
              {/if}
            {/each}
          </div>
        </div>
      {/if}
    </div>
  </div>

  <div class="other-gua-row">
    <div class="zcjh-gua-row ">
      <div
        class={"gua-z gua-btn " + btn_effect}
        on:click={() => showGua("gua-z")}
      >
        {#if $selectedLanguage == "TW"}
          <strong>綜卦：</strong>
        {:else}
          <strong>综卦：</strong>
        {/if}
        {findGua(zongGua(number2code(numStr)), $selectedLanguage)}
        <div class="gua-pic">
          {#each reverseString(zongGua(number2code(numStr))) as digit, i}
            {#if digit == "0"}
              <YinYao yaoColor={""} size={"size2"} />
            {:else}
              <YangYao yaoColor={""} size={"size2"} />
            {/if}
          {/each}
        </div>
      </div>
      <div
        class={"gua-c gua-btn " + btn_effect}
        on:click={() => showGua("gua-c")}
      >
        {#if $selectedLanguage == "TW"}
          <strong>錯卦：</strong>
        {:else}
          <strong>错卦：</strong>
        {/if}
        {findGua(cuoGua(number2code(numStr)), $selectedLanguage)}
        <div class="gua-pic">
          {#each reverseString(cuoGua(number2code(numStr))) as digit, i}
            {#if digit == "0"}
              <YinYao yaoColor={""} size={"size2"} />
            {:else}
              <YangYao yaoColor={""} size={"size2"} />
            {/if}
          {/each}
        </div>
      </div>
      <div
        class={"gua-j gua-btn " + btn_effect}
        on:click={() => showGua("gua-j")}
      >
        <strong>交卦：</strong>{findGua(
          jiaoGua(number2code(numStr)),
          $selectedLanguage
        )}
        <div class="gua-pic">
          {#each reverseString(jiaoGua(number2code(numStr))) as digit, i}
            {#if digit == "0"}
              <YinYao yaoColor={""} size={"size2"} />
            {:else}
              <YangYao yaoColor={""} size={"size2"} />
            {/if}
          {/each}
        </div>
      </div>
      <div
        class={"gua-h gua-btn " + btn_effect}
        on:click={() => showGua("gua-h")}
      >
        <strong>互卦-卦中卦(2-5):</strong>{findGua(
          huGua(number2code(numStr)),
          $selectedLanguage
        )}
        <div class="gua-pic">
          {#each reverseString(huGua(number2code(numStr))) as digit, i}
            {#if digit == "0"}
              <YinYao yaoColor={""} size={"size2"} />
            {:else}
              <YangYao yaoColor={""} size={"size2"} />
            {/if}
          {/each}
        </div>
      </div>
    </div>
    <div class="gig-row ">
      <div
        class={"gig14 gua-btn " + btn_effect}
        on:click={() => showGua("gig14")}
      >
        <strong>卦中卦(1-4):</strong>{findGua(
          gig14(number2code(numStr)),
          $selectedLanguage
        )}
        <!-- {#each gig14(number2code(reverseString(numStr))) as digit, i} -->
        <!-- {#each gig14(reverseString(number2code(numStr))) as digit, i} -->
        <!-- {#each "000001" as digit, i} -->
        <div class="gua-pic">
          {#each reverseString(gig14(number2code(numStr))) as digit, i}
            {#if digit == "0"}
              <YinYao yaoColor={""} size={"size2"} />
            {:else}
              <YangYao yaoColor={""} size={"size2"} />
            {/if}
          {/each}
        </div>
      </div>
      <div
        class={"gig15 gua-btn " + btn_effect}
        on:click={() => showGua("gig15")}
      >
        <strong>卦中卦(1-5):</strong>{findGua(
          gig15(number2code(numStr)),
          $selectedLanguage
        )}
        <div class="gua-pic">
          {#each reverseString(gig15(number2code(numStr))) as digit, i}
            {#if digit == "0"}
              <YinYao yaoColor={""} size={"size2"} />
            {:else}
              <YangYao yaoColor={""} size={"size2"} />
            {/if}
          {/each}
        </div>
      </div>
      <div
        class={"gig26 gua-btn " + btn_effect}
        on:click={() => showGua("gig26")}
      >
        <strong>卦中卦(2-6):</strong>{findGua(
          gig26(number2code(numStr)),
          $selectedLanguage
        )}
        <div class="gua-pic">
          {#each reverseString(gig26(number2code(numStr))) as digit, i}
            {#if digit == "0"}
              <YinYao yaoColor={""} size={"size2"} />
            {:else}
              <YangYao yaoColor={""} size={"size2"} />
            {/if}
          {/each}
        </div>
      </div>
      <div
        class={"gig36 gua-btn " + btn_effect}
        on:click={() => showGua("gig36")}
      >
        <strong>卦中卦(3-6):</strong>{findGua(
          gig36(number2code(numStr)),
          $selectedLanguage
        )}
        <div class="gua-pic">
          {#each reverseString(gig36(number2code(numStr))) as digit, i}
            {#if digit == "0"}
              <YinYao yaoColor={""} size={"size2"} />
            {:else}
              <YangYao yaoColor={""} size={"size2"} />
            {/if}
          {/each}
        </div>
      </div>
    </div>
    <div
      class="gua-info "
      id="gua-info"
      style="display:{displayGuaInfo ? 'block' : 'none'}"
    >
      <GuaBriefing numStr={selectedGuaNumStr} {sectionName} />
    </div>
  </div>
</div>

<style>
  .gua-header {
    display: grid;
    grid-template-columns: 1fr 1fr;
    height: 160px;
  }
  .gua-name {
    /* display: grid;
    grid-template-columns: 1fr; */
    padding-left: 5px;
    margin: auto;
  }
  .gua-changing-info {
    display: grid;
    grid-template-columns: 1fr;
  }

  .yao-changing {
    padding-left: 5px;
    margin: auto;
  }
  .yao-moving {
    padding-left: 5px;
    margin: auto;
  }

  .zhi-gua-row {
    display: grid;
    grid-template-columns: 1fr 1fr;
    height: 200px;
  }
  .zhi1 {
    padding-left: 5px;
    margin: auto;
  }
  .zhi2 {
    padding-left: 5px;
    margin: auto;
  }
  .zhi1:hover {
    cursor: pointer;
  }
  .zhi2:hover {
    cursor: pointer;
  }
  .other-gua-row {
    display: grid;
    grid-template-columns: 1fr;
  }
  .zcjh-gua-row {
    display: grid;
    grid-template-columns: 1fr 1fr 1fr 1fr;
    height: 200px;
  }
  .gua-z {
    padding-left: 5px;
    margin: auto;
  }
  .gua-c {
    padding-left: 5px;
    margin: auto;
  }
  .gua-j {
    padding-left: 5px;
    margin: auto;
  }
  .gua-h {
    padding-left: 5px;
    margin: auto;
  }
  .gua-z:hover {
    cursor: pointer;
  }
  .gua-c:hover {
    cursor: pointer;
  }
  .gua-j:hover {
    cursor: pointer;
  }
  .gua-h:hover {
    cursor: pointer;
  }
  .gig-row {
    display: grid;
    grid-template-columns: 1fr 1fr 1fr 1fr;
    height: 200px;
  }
  .gig14 {
    padding-left: 5px;
    margin: auto;
  }
  .gig15 {
    padding-left: 5px;
    margin: auto;
  }
  .gig26 {
    padding-left: 5px;
    margin: auto;
  }
  .gig36 {
    padding-left: 5px;
    margin: auto;
  }
  .gig14:hover {
    cursor: pointer;
  }
  .gig15:hover {
    cursor: pointer;
  }
  .gig26:hover {
    cursor: pointer;
  }
  .gig36:hover {
    cursor: pointer;
  }
  .gua-info {
    width: 100%;
  }
  .gua-btn {
    min-width: 80px;
    max-width: 120px;
    height: 170px;
    border-radius: 8px;
    box-shadow: 0 8px 16px 0 rgba(0, 0, 0, 0.2),
      0 6px 20px 0 rgba(0, 0, 0, 0.19);
    padding: 10px;
  }
  .gua-pic {
    padding-top: 8px;
  }
</style>
